<template>
  <div class="line">
    <div class="presLine" ref="pres_statistics"></div>
  </div>
</template>

<script>
  import EChart from 'echarts'

  export default {
    props:{
      presData:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data() {
      return {
        pres_statistics: {
          option: {},
          chart: null,
          element: {},
        },
        pres_data:{},
        x_data:['--','--','--','--','--','--'],
        input_data:[0,0,0,0,0,0],   //进口压力数据
        output_data:[0,0,0,0,0,0],    //出口压力数据
        chartArray:['pres_statistics'],
        x_dataLen:0
      }
    },
    mounted() {
      //   this.$nextTick(() => {
      //     this.initData();
      //   })
      let that = this;
      setTimeout(() => {
        window.addEventListener('resize',function(){
          // that.pres_statistics.chart.resize();
        })
      }, 10);
      // this.$nextTick(()=>{
      //     setTimeout(()=>{
      //         that.select_item();
      //     },1000)
      // });
    },
    watch:{
      presData:{
        handler:function(newVal,oldVal){
          setTimeout(()=>{
            this.pageInit();
          },500)
        },
        deep:true
      }
    },
    beforeDestroy(){
      window.removeEventListener('resize',this.onWindowResize);
      if(this.interval){
        clearInterval(this.interval);
      }
    },
    destory() {
      //   window.onresize = null;
    },
    methods: {
      //默认选中一项
      select_item(){
        let vue = this;
        if(vue.pres_data.alarmTime){
          this.interval=setInterval(function(){
            let alarmTime = (vue.pres_data.alarmTime).split(" ")[1].substring(0,5);
            let presdata = vue.pres_data.input
            for(var i in presdata){
              let time = (presdata[i].time).split(" ")[1].substring(0,5);
              if(alarmTime==time){
                vue.pres_statistics.chart.dispatchAction({
                  type: 'showTip',
                  seriesIndex:0,  // 显示第几个series
                  dataIndex: i // 显示第几个数据
                });
              }
            }
          })
        }

      },
      pageInit(){
        this.pres_data = this.$deepClone(this.presData);
        this.x_data = [];
        this.y_Data = [];

        console.log("数据输出-=-=-=",this.pres_data.name)


        for(let item in this.pres_data.time){
          let time = this.pres_data.time[item];
          this.x_data.push(time.split(" ")[1].substring(0,5));
        }
        console.log('x_data=-=-=-=-=-=-=-='+ JSON.stringify(this.x_data));

        for(let item in this.pres_data.list){
          this.y_Data.push(this.pres_data.list[item]);
        }
        console.log('output_data=-=-=-=-=-=-=-='+ JSON.stringify(this.y_Data));
        if(this.x_data.length<=10){
          this.x_dataLen = 1;
        }else if(this.x_data.length<=40){
          this.x_dataLen = 5;
        } else if(this.x_data.length>40){
          this.x_dataLen = 15;
        }

          this.initData();

      },
      initData() {
        var serieData = [];
        var colors = ["#0088D4","#89BD1B","#00eaf0"];
        for(var v=0; v < this.y_Data.length ; v++){
          var serie = {
            name:this.y_Data[v].name,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            showSymbol: false,
            lineStyle: {
              // normal: {
              //   width: 1
              // }
            normal: {
               color:"#00eaf0"   // 线条颜色
            }
            },

            itemStyle: {
              normal: {
                color: colors[v],
                borderColor:colors[v],
                borderWidth: 12
              }
            },
            data: this.y_Data[v].data
          };
          serieData.push(serie)
        }



        this.pres_statistics.option = {
          title:{
            text:this.pres_data.title,
            right:20,
            textStyle:{
              color:'#ffffff',
              fontSize:18,
              fontWeight:'normal'
            }
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor:'#123e8e',
            axisPointer: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          legend: {
            icon: 'rect',
            itemWidth: 14,
            itemHeight: 5,
            itemGap: 13,
            data:this.pres_data.name,
            right: '4%',
            top:'15%',
            textStyle: {
              fontSize: 11,
              color: '#00a9b6'
            }
          },
          grid: {
            left: '5%',
            top:"30%",
            bottom: "5%",
            right:"10%",
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#0068b7'
              }
            },
            axisLabel:{
              interval:this.x_dataLen,
              rotate:40,
              textStyle:{
                color:'#9ea7c4',
                fontSize:10
              }
            },
            axisTick : {
              show: true,
              inside:true,  //x轴的刻度朝内
            },
            // data: ['10分', '20分', '30分', '40分', '50分', '60分']
            data:this.x_data,
          },],
          yAxis: [{
            type: 'value',
            name:'('+this.pres_data.unit+')',
            nameTextStyle: {
              color: "#91a8b6",
              fontSize: 10,
              padding: [0, 0, 0, -20]
            },
            type: 'value',
            axisTick : {
              show: false
            },
            splitLine: {
              show:true,
              lineStyle: {
                color: '#003b8b',
              },
            },
            axisLabel:{
              textStyle:{
                color:'#91a9c0',
                fontSize:10
              }
            },
            axisLine: {
              show: true,
              lineStyle:{
                color:'#0068b7'
              }
            },
            
          }],
          series:serieData

          // series: [{
          //       name: '进口压力',
          //       type: 'line',
          //       smooth: true,
          //       symbol: 'circle',
          //       symbolSize: 5,
          //       showSymbol: false,
          //       lineStyle: {
          //           normal: {
          //               width: 1
          //           }
          //       },
          //       areaStyle: {
          //
          //       },
          //       itemStyle: {
          //           normal: {
          //               color: 'rgb(137,189,27)',
          //               borderColor: 'rgba(137,189,2,0.27)',
          //               borderWidth: 12
          //
          //           }
          //       },
          //       // data: [220, 182, 191, 134, 150, 120, 110, 125, 145, 122, 165, 122]
          //       data:this.input_data
          //   }, {
          //       name: '出口压力',
          //       type: 'line',
          //       smooth: true,
          //       symbol: 'circle',
          //       symbolSize: 5,
          //       showSymbol: false,
          //       lineStyle: {
          //           normal: {
          //               width: 1
          //           }
          //       },
          //       areaStyle: {
          //           normal: {
          //               color: new EChart.graphic.LinearGradient(0, 0, 0, 1, [{
          //                   offset: 0,
          //                   color: 'rgba(0, 136, 212, 0.3)'
          //               }, {
          //                   offset: 0.8,
          //                   color: 'rgba(0, 136, 212, 0)'
          //               }], false),
          //               shadowColor: 'rgba(0, 0, 0, 0.1)',
          //               shadowBlur: 10
          //           }
          //       },
          //       itemStyle: {
          //           normal: {
          //               color: 'rgb(0,136,212)',
          //               borderColor: 'rgba(0,136,212,0.2)',
          //               borderWidth: 12
          //
          //           }
          //       },
          //       // data: [120, 110, 125, 145, 122, 165, 122, 220, 182, 191, 134, 150]
          //       data:this.input_data
          //   }]
        };
        if(this.pres_statistics.chart!=null&&this.pres_statistics.chart!=''&&this.pres_statistics.chart!=undefined){
          this.pres_statistics.chart.dispose();
        }
        this.pres_statistics.chart = EChart.init(this.$refs.pres_statistics);
        this.pres_statistics.chart.setOption(this.pres_statistics.option)
      },
      //释放图表，销毁对象
      disposeAllChart(){
        let i = 0 , len = this.chartArray.length
        for (;i < len; i++){
          let a = this.chartArray[i]
          if(this[a].chart){
            this[a].chart.dispose()
          }
        }
        this.initData()
      }
    }
  }
</script>
<style lang="less" scoped>
  .line{
    width: 100%;
    height: 100%;
    .presLine{
      width: 100%;
      height: 100%;
    }
  }
  .presLine {
    border-right: 0;
    border-left: 0;
    /* width: 350px;
    height: 220px; */
    /* background-color: red; */
    // width: 100%;
    // height: 220px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/pres_line.vue